import { useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { forgotPassword, getErrorMessage } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft } from "lucide-react";

export default function ForgotPasswordForm({ onBack }) {
  const { lang, t } = useLang();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await forgotPassword(email);
      setSent(true);
      toast.success(t.resetLinkSent);
    } catch (err) {
      if (err?.response?.status === 429) toast.error(t.tooManyAttempts);
      else toast.error(getErrorMessage(err));
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="forgot-password-form">
      <button onClick={onBack} className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[#5C6B6D] hover:text-[#0F5F63] mb-6"
        data-testid="back-to-login-btn">
        <ArrowLeft className="w-3.5 h-3.5" /> {t.backToLogin}
      </button>
      <h1 className={`${lang === "ar" ? "font-serif-ar" : "font-serif-en"} text-4xl text-[#0F5F63] font-semibold`}>
        {t.resetPasswordTitle}
      </h1>
      <p className="mt-3 text-sm text-[#5C6B6D]">{t.resetPasswordHint}</p>

      {sent ? (
        <p className="mt-8 rounded-2xl bg-[#F4F2EB] p-6 text-sm text-[#0F5F63]" data-testid="reset-link-sent-msg">
          {t.resetLinkSent}
        </p>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <Label htmlFor="fpe" className="text-xs uppercase tracking-widest text-[#5C6B6D]">{t.email}</Label>
            <Input id="fpe" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email-input"
              className="mt-2 rounded-full bg-[#F4F2EB] border-0 focus-visible:ring-1 focus-visible:ring-[#0F5F63] h-12 px-5"
              placeholder="you@example.com" autoFocus />
          </div>
          <Button type="submit" disabled={busy} data-testid="forgot-submit-btn"
            className="w-full rounded-full h-12 bg-[#0F5F63] hover:bg-[#0A4548] text-[#FDFBF7] uppercase tracking-widest text-xs">
            {t.sendResetLink}
          </Button>
        </form>
      )}
    </div>
  );
}
